import Cookies from "js-cookie";

const AUTH_STORAGE_KEYS = [
  "token",
  "authToken",
  "accessToken",
  "jwt",
  "userToken",
  "user",
  "currentUser",
  "profile",
  "isLoggedIn",
  "loggedIn"
];

export function clearAuthSession() {
  try {
    Cookies.remove("token");
    Cookies.set("token", "", { expires: -1 });
  } catch (e) {
    // Ignore cookie errors
  }

  AUTH_STORAGE_KEYS.forEach((key) => {
    try {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    } catch (e) {
      // Ignore browser storage errors
    }
  });
}

export function replaceAuthSession({ tokenKey = "token", token, userKey = "user", user }) {
  clearAuthSession();

  try {
    if (tokenKey === "token" && token) {
      Cookies.set("token", token, { expires: 365 });
    }

    if (token) {
      localStorage.setItem(tokenKey, token);
    }

    if (user) {
      localStorage.setItem(userKey, JSON.stringify(user));
    }
  } catch (e) {
    // Ignore browser storage errors
  }
}

export function markAuthRedirect(messageKey = "auth.login_improved_sign_in_again") {
  try {
    sessionStorage.setItem("auth_redirect_message_key", messageKey);
  } catch (e) {
    // Ignore browser storage errors
  }
}
